export const SUCCESS_PROFILE_DECISION_REPLAY_VERSION = 'northstar-success-profile-decisions-v3';

export type SuccessProfileDecisionStatus = 'Included' | 'Denied';

export interface SuccessProfileDecisionProposal {
  Id: string;
  Group: string;
  Kind: 'Ability' | 'Positive behavior' | 'Counterproductive behavior';
  Name: string;
  ProposedRating: string;
  Evidence: string;
  Status: SuccessProfileDecisionStatus;
}

const deepFreeze = <T,>(value: T): T => {
  if (value !== null && typeof value === 'object' && !Object.isFrozen(value)) {
    Object.values(value as Record<string, unknown>).forEach(deepFreeze);
    Object.freeze(value);
  }
  return value;
};

export const SUCCESS_PROFILE_DECISION_REPLAY_CANONICAL: readonly SuccessProfileDecisionProposal[] = deepFreeze([
  {
    Id: 'profile-ability-inspection',
    Group: 'Performant',
    Kind: 'Ability',
    Name: 'Inspects commercial equipment systematically',
    ProposedRating: 'Advanced',
    Evidence: 'Eight scheduled inspections completed with findings documented.',
    Status: 'Included',
  },
  {
    Id: 'profile-positive-escalation',
    Group: 'Communication',
    Kind: 'Positive behavior',
    Name: 'Escalates ambiguous safety risks before continuing work',
    ProposedRating: 'Sometimes',
    Evidence: 'One ambiguous condition required supervisor follow-up before escalation.',
    Status: 'Included',
  },
  {
    Id: 'profile-ability-maintenance',
    Group: 'Sustainable',
    Kind: 'Ability',
    Name: 'Performs preventive maintenance safely',
    ProposedRating: 'Advanced',
    Evidence: 'Preventive service followed established procedures and site requirements.',
    Status: 'Included',
  },
  {
    Id: 'profile-ability-adaptation',
    Group: 'Adaptable',
    Kind: 'Ability',
    Name: 'Adjusts the service plan when conditions change',
    ProposedRating: 'Intermediate',
    Evidence: 'Service steps were revised when equipment conditions differed from the initial brief.',
    Status: 'Included',
  },
  {
    Id: 'profile-positive-documentation',
    Group: 'Communication',
    Kind: 'Positive behavior',
    Name: 'Documents service findings promptly',
    ProposedRating: 'Usually',
    Evidence: 'Service records were submitted on time with maintenance actions documented.',
    Status: 'Included',
  },
  {
    Id: 'profile-counterproductive-proceeding',
    Group: 'Sustainable',
    Kind: 'Counterproductive behavior',
    Name: 'Proceeds when safety conditions are unclear',
    ProposedRating: 'Rarely',
    Evidence: 'Lower frequency is better for this counterproductive behavior.',
    Status: 'Included',
  },
]);

const clone = <T,>(value: T): T => JSON.parse(JSON.stringify(value));

export const createSuccessProfileDecisionReplay = (): SuccessProfileDecisionProposal[] =>
  clone([...SUCCESS_PROFILE_DECISION_REPLAY_CANONICAL]);

export const successProfileDecisionReplayFingerprint = (proposals: readonly SuccessProfileDecisionProposal[]): string =>
  JSON.stringify(proposals);

export const expectedSuccessProfileDecisionReplayFingerprint = (): string =>
  JSON.stringify(SUCCESS_PROFILE_DECISION_REPLAY_CANONICAL);
